import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTable"><Path d="M11 3H21V9H11V3Z" fill="currentColor"/><Path d="M9 3H3V9H9V3Z" fill="currentColor"/><Path d="M3 11V21L9 21V11H3Z" fill="currentColor"/><Path d="M11 21L21 21V11H11V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTable;
